import styled from "styled-components";

export const Card = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 8px;
  border-radius: 6px;
  background: ${({ $selected }) => ($selected ? "#fff" : "#f4f5f6")};
  border: 1px solid ${({ $selected }) => ($selected ? "#1b6b78" : "transparent")};
  box-sizing: border-box;
`;

export const Thumb = styled.img`
  width: 96px;
  height: 96px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: 4px;
  background: #e8ecef;
`;

export const Body = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 2px 0;
`;

export const ItemTitle = styled.span`
  font-size: 0.9rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const ItemDescription = styled.span`
  font-size: 0.8rem;
  line-height: 1.4;
  color: #333;
  white-space: pre-line;
`;

export const ItemMeta = styled.span`
  font-size: 0.72rem;
  color: #8a959e;
`;
